import * as React from 'react';
import { Button } from 'react-covideo-common';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import CloseIcon from 'lib/images/CloseIcon';
import { Modal } from 'lib/components';
import { PackageWithAdditionalInfo } from 'lib/const/PackageAdditionalInfo';
import { useHistory } from 'react-router';
import LinkExternalIcon from 'lib/images/LinkExternalIcon';

const ModalItem = styled.div`
  box-sizing: border-box;
  width: 592px;
  padding: 32px;
  min-height: 232px;
  background-color: ${theme.palette.white};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  h2 {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: ${theme.palette.black_1_100};
    margin: 0;
  }
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  color: ${theme.palette.black_1_100};
`;

const CloseButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${theme.palette.coal};
  &:hover {
    cursor: pointer;
  }
`;

const Content = styled.div``;

const ButtonsWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
`;

const Info = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.palette.gray100};
  margin: 32px 0;
`;

type Props = {
  handleModalClose: () => void;
  currentPackageDetails: PackageWithAdditionalInfo;
  newPackageDetails: PackageWithAdditionalInfo;
};

export const ModalCantDowngradePackage = ({
  handleModalClose,
  newPackageDetails,
  currentPackageDetails,
}: Props) => {
  const history = useHistory();
  const isDowngrading = newPackageDetails?.id !== currentPackageDetails?.id;

  const title = isDowngrading
    ? `Can’t Downgrade to ${newPackageDetails.title} Yet`
    : `Can’t Cancel ${currentPackageDetails.title} Plan Yet`;
  const text = isDowngrading
    ? `You have to deactivate all active users from your ${currentPackageDetails.title} plan to be able to downgrade to ${newPackageDetails.title}.`
    : `You have to deactivate all active users from your ${currentPackageDetails.title} plan to be able to cancel.`;

  return (
    <Modal>
      <ModalItem>
        <Header>
          <h2>{title}</h2>
          <CloseButtonWrapper>
            <CloseIcon
              width={'24px'}
              height={'24px'}
              onClick={handleModalClose}
            />
          </CloseButtonWrapper>
        </Header>
        <Content>
          <Info>{text}</Info>
        </Content>
        <ButtonsWrapper>
          <Button
            variant='primary'
            text='Manage Users'
            onClick={() => history.push('/users/list')}
            icon={
              <LinkExternalIcon
                width={16}
                height={16}
                color={theme.palette.white}
              />
            }
          />
        </ButtonsWrapper>
      </ModalItem>
    </Modal>
  );
};
